import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import reportWebVitals from "./reportWebVitals.ts";
import { env } from "./config/env.ts";
import Auth0Provider from "./common/Auth0Provider";
import { store } from "@store/store.tsx";
import { Provider } from "react-redux";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <Auth0Provider
                cache={{
                    get: (key) => sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key)) : undefined,
                    set: (key, value) => sessionStorage.setItem(key, JSON.stringify(value)),
                    remove: (key) => sessionStorage.removeItem(key),
                    allKeys: () => Object.keys(sessionStorage)
                }}
                useRefreshTokens
                domain={env.auth0Domain!}
                clientId={env.auth0ClientId!}
                authorizationParams={{
                    redirect_uri: window.location.href.toLowerCase().includes('mapp') ? undefined : window.location.origin,
                    useRefreshTokens: true,
                    audience: env.baseUrl,
                    scope: "openid profile email offline_access"
                }}
                onRedirectCallback={(appState) => {
                    window.history.replaceState({}, document.title, appState?.returnTo ?? window.location.pathname);
                }}
            >
                <App />
            </Auth0Provider>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
